// extracted by mini-css-extract-plugin
module.exports = {"container":"SupportHubHomeImage_container__1ADuZ","hero":"SupportHubHomeImage_hero__cy3Tp","image-container":"SupportHubHomeImage_image-container__O5yjX"};